/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useTranslation } from 'react-i18next';
import proverLogo from '../../Resources/prover.svg';
import s from './Header.module.scss';

const Header = () => {
  const { i18n } = useTranslation();

  const language = i18n.language.split('-')[0];

  const changeLanguage = lang => () => {
    i18n.changeLanguage(lang);
  };

  return (
    <header className={s.header}>
      <a href="https://prover.io">
        <img src={proverLogo} alt="Prover" />
      </a>
      <div className={s.languages} key={Math.random()}>
        <ul className={s.group}>
          <li className={s.title}>{language === 'vi' ? 'VN' : language.toUpperCase()}</li>
          {language !== 'en' && (
            <li onClick={changeLanguage('en')}>
              <span>EN</span>
            </li>
          )}
          {language !== 'ru' && (
            <li onClick={changeLanguage('ru')}>
              <span>RU</span>
            </li>
          )}
          {language !== 'vi' && (
            <li onClick={changeLanguage('vi')}>
              <span>VN</span>
            </li>
          )}
        </ul>
      </div>
    </header>
  );
};

export default Header;
